import React from 'react';
import { Card, CardBody } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import ToolButton from '../../../common/ToolButton';
import BackButton from '../../../common/BackButton';

const VehicleTools = ({
  history
}) => {
  return (
    <Card>
      <CardBody>
        <ToolButton
          color={"primary"}
          handleClick={() => history.push("/vehicle")}
          icon={"plus"}
          text={"Dodaj Pojazd"}
        />
        <BackButton />
      </CardBody>
    </Card>
  )
}

export default withRouter(VehicleTools);
